<template>
  <div class="h-20 me-16 w-100" style="height: 340px;">
    <div class="card background-image pe-16 py-48 border border-1 rounded mb-sm-40 mb-md-0 mb-lg-0 mb-xl-0"
      @mouseover="cardHover(true)" @mouseout="cardHover(false)" :style="{
        background: card.featuredImage?.storageUrl ? `url('${card?.featuredImage?.storageUrl}')` : cardBackgroundColor,
        backgroundSize: '100% 100%',
      }">
      <v-row class="name-total-days-row">
        {{ card?.name }}
        <v-col class="text-end">
          <div class="total-days">{{ card?.tourDaysCount }} {{ card?.tourDaysCount === 1 ? 'Day' : 'Days' }} </div>
        </v-col>
      </v-row>
      <div class="hover_content rounded" :style="{ backgroundImage: `url('${card?.featuredImage?.originalUrl}')` }">
        <div class="top-section"></div>
        <div class="bottom-section">
          <v-row style="margin-bottom: 15px;">
            <v-col class="hovered_name p-0">
              <div>
                <h6>{{ card?.name }}</h6>
              </div>
            </v-col>
          </v-row>
          <div class="origin-destination-row">
            No . of  Days &nbsp;:&nbsp; {{ card?.tourDaysCount }}
          </div>
          <div class="origin-destination-row">
            {{ card.origin?.name }}
            <v-icon class="travelArrowIcon" icon="arrow-right" />
            <span>{{ card.destination?.name }}</span>
          </div>
          <div class="travelType">
            <span>{{ $t("general.shared.travelType") }}:</span>
            {{ capitalizeFirstLetter(card.travelType) }}
            <svg v-if="card.travelType == 'bike'" width="22" height="22" viewBox="0 0 32 32" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.16799 15.568H19.2672C19.4816 15.568 19.68 15.4624 19.7984 15.2864C20.1344 14.7904 20.3104 14.2112 20.3104 13.6096C20.3104 11.9552 18.9632 10.608 17.3088 10.608C14.5952 10.608 12.0608 12.0096 10.608 14.288H7.16799C3.74399 14.288 0.956787 17.0752 0.956787 20.4992C0.956787 20.8512 1.24479 21.1392 1.59679 21.1392C1.94879 21.1392 2.23679 20.8512 2.23679 20.4992C2.23679 17.7792 4.44799 15.568 7.16799 15.568Z"
                fill="white" />
              <path
                d="M25.4976 13.8432C25.8496 13.8432 26.1376 13.5552 26.1376 13.2032V10.656C26.1376 10.304 25.8496 10.016 25.4976 10.016C24.4416 10.016 23.584 10.8736 23.584 11.9296C23.584 12.9824 24.4448 13.8432 25.4976 13.8432Z"
                fill="white" />
              <path
                d="M13.1712 17.9584C12.8192 17.9584 12.5312 18.2464 12.5312 18.5984C12.5312 18.9504 12.8192 19.2384 13.1712 19.2384H16.7712C17.1232 19.2384 17.4112 18.9504 17.4112 18.5984C17.4112 18.2464 17.1232 17.9584 16.7712 17.9584H13.1712Z"
                fill="white" />
              <path
                d="M18.1344 16.8288C18.1344 16.4768 17.8464 16.1888 17.4944 16.1888H12.2176C11.8656 16.1888 11.5776 16.4768 11.5776 16.8288C11.5776 17.1808 11.8656 17.4688 12.2176 17.4688H17.4944C17.8464 17.4688 18.1344 17.1808 18.1344 16.8288Z"
                fill="white" />
              <path
                d="M26.752 19.6896C26.304 19.6896 25.9392 20.0544 25.9392 20.5024C25.9392 20.9504 26.304 21.3152 26.752 21.3152C27.2 21.3152 27.5648 20.9504 27.5648 20.5024C27.5616 20.0512 27.2 19.6896 26.752 19.6896Z"
                fill="white" />
              <path
                d="M26.752 16.208C26.1792 16.208 25.6352 16.3232 25.136 16.528L20.4352 8.61759C19.9584 7.81439 18.8928 7.20959 17.9616 7.20959H15.472C15.12 7.20959 14.832 7.49759 14.832 7.84959C14.832 8.20159 15.12 8.48959 15.472 8.48959H17.9616C18.4384 8.48959 19.0944 8.86079 19.3376 9.27039L21.9424 13.6544L18.256 19.8592H11.408C11.0976 17.7952 9.3184 16.208 7.1712 16.208C4.8064 16.208 2.88 18.1312 2.88 20.4992C2.88 22.864 4.8064 24.7904 7.1712 24.7904C9.3184 24.7904 11.0976 23.2032 11.408 21.1392H18.3008C18.704 21.1392 19.1296 20.896 19.3344 20.5504L22.688 14.9088L24.0384 17.1808C23.0784 17.968 22.464 19.1616 22.464 20.4992C22.464 22.864 24.3904 24.7904 26.7552 24.7904C29.12 24.7904 31.0464 22.864 31.0464 20.4992C31.0432 18.1344 29.1168 16.208 26.752 16.208ZM7.168 22.592C6.016 22.592 5.0752 21.6544 5.0752 20.4992C5.0752 19.344 6.0128 18.4064 7.168 18.4064C8.3232 18.4064 9.2608 19.344 9.2608 20.4992C9.2608 21.6544 8.32 22.592 7.168 22.592ZM26.752 22.592C25.6 22.592 24.6592 21.6544 24.6592 20.4992C24.6592 19.344 25.5968 18.4064 26.752 18.4064C27.904 18.4064 28.8448 19.344 28.8448 20.4992C28.8448 21.6544 27.904 22.592 26.752 22.592Z"
                fill="white" />
              <path
                d="M7.16796 19.6896C6.71996 19.6896 6.35516 20.0544 6.35516 20.5024C6.35516 20.9504 6.71996 21.3152 7.16796 21.3152C7.61596 21.3152 7.98076 20.9504 7.98076 20.5024C7.98076 20.0512 7.61596 19.6896 7.16796 19.6896Z"
                fill="white" />
            </svg>
            <svg v-if="card.travelType == 'horse'" width="22" height="22" viewBox="0 0 32 32" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.83929 18.6243L10.134 21.8592C10.17 21.9101 10.1879 21.9716 10.1847 22.0339L10.1318 23.0613L11.4539 23.5513C11.7012 22.9794 11.6501 22.827 11.4907 22.3523C11.4753 22.3063 11.4722 22.2572 11.4817 22.2097L11.6155 21.5411L9.94122 18.618C9.86769 18.4896 9.90792 18.3261 10.0326 18.2466C10.6582 17.8473 11.0475 17.2872 11.2817 16.8207C10.588 16.4876 10.0771 16.1516 9.78687 15.9425C9.28345 16.8998 8.64569 17.7799 7.83929 18.6243Z"
                fill="white" />
              <path
                d="M18.0694 17.6022L17.7474 24.5196L18.3099 25.3821H19.8271C19.744 24.958 19.3663 24.4962 19.2005 24.3295C19.1389 24.2676 19.1098 24.18 19.1225 24.0935L20.0679 17.649C19.4333 17.5513 18.765 17.5356 18.0694 17.6022Z"
                fill="white" />
              <path
                d="M6.76606 10.1525C6.95022 9.99039 7.15267 9.85008 7.37308 9.73159C6.55819 9.61052 5.41798 9.67149 4.6708 10.6746C4.3068 11.1635 4.13858 11.7788 4.19716 12.4073C4.24155 12.8838 4.27963 13.5956 4.20881 14.2806C4.16914 14.6644 4.09931 15.0006 4 15.2875C4.39381 15.0522 4.90566 14.6695 5.43506 14.0638C5.40622 12.2709 5.85278 10.9564 6.76606 10.1525Z"
                fill="white" />
              <path
                d="M18.1447 12.9377C19.3204 12.6688 20.3284 11.9554 20.8933 10.9538C20.979 10.802 21.0608 10.6415 21.1399 10.4862C21.2432 10.2835 21.3499 10.0739 21.471 9.87122C22.0332 8.92961 22.9105 8.17855 23.612 7.62941C24.0047 7.32191 24.4097 7.0318 24.8212 6.76282C24.7009 6.73183 24.5744 6.70436 24.4422 6.68204C23.0121 6.44047 21.6244 6.88238 20.3176 7.99557C20.001 8.26533 19.7004 8.5138 19.4108 8.74132C19.3887 8.93178 19.3694 9.1246 19.3508 9.31225C19.2556 10.2732 19.1572 11.2668 18.6385 12.19C18.5831 12.2886 18.3888 12.6246 18.1447 12.9377Z"
                fill="white" />
              <path
                d="M27.9985 6.9015C27.7286 6.85794 27.1468 6.84611 26.5829 7.37105C26.4843 7.46286 26.3339 7.47045 26.2266 7.38908C26.2226 7.38608 25.9533 7.18663 25.495 6.99167C24.9695 7.31522 24.4516 7.67614 23.9537 8.06594C23.2901 8.58545 22.4623 9.29242 21.947 10.1554C21.8355 10.3422 21.7375 10.5344 21.6339 10.7379C21.5521 10.8983 21.4676 11.0642 21.3762 11.2262C20.9702 11.946 20.3557 12.5482 19.5992 12.9677C18.8738 13.37 18.0453 13.5918 17.2031 13.609C17.2012 13.6091 17.1993 13.6091 17.1974 13.6091C17.0469 13.6091 16.9234 13.4887 16.9203 13.3375C16.9172 13.1845 17.0388 13.0579 17.1918 13.0547C17.2448 13.0536 17.4154 12.9635 17.6814 12.6299C17.9134 12.339 18.1027 12.0117 18.1552 11.9184C18.6169 11.0965 18.7054 10.2033 18.7991 9.2576C18.8011 9.23728 18.8031 9.21664 18.8052 9.19622C17.9135 9.83124 17.1006 10.241 16.2022 10.4107C15.8481 10.4776 15.4805 10.508 15.0874 10.508C14.0308 10.508 12.7884 10.2884 11.1174 9.96753C9.31873 9.62208 7.97794 9.82434 7.13235 10.5687C6.26913 11.3285 5.89104 12.6659 6.00859 14.5437C6.02244 14.765 6.04909 14.9891 6.07516 15.1998C6.17585 16.0123 5.82554 16.9056 5.03395 17.8548C5.03298 17.856 5.03199 17.8571 5.03102 17.8583L4.32782 18.674V24.7351L4.62818 25.3821H6.58135C6.51412 25.1819 6.32407 24.8305 5.79562 24.3172C5.74188 24.265 5.71157 24.1933 5.71157 24.1184V19.927C5.71157 19.8426 5.7501 19.7627 5.81621 19.7101C7.51018 18.3626 8.6621 16.9925 9.44138 15.3983C9.4789 15.3215 9.54973 15.2663 9.63335 15.2487C9.71695 15.2311 9.80401 15.2531 9.8693 15.3082C9.87687 15.3146 10.6593 15.9667 11.9555 16.5171C13.1439 17.0217 15.0226 17.5425 17.224 17.1577C17.4042 17.1262 17.5829 17.0998 17.7602 17.0782C17.7608 17.0781 17.7614 17.0781 17.7619 17.078C18.8672 16.9435 19.9146 17.001 20.8821 17.2504C21.6907 17.4588 22.4515 17.8609 23.0821 18.4131C23.7106 18.9634 24.211 19.6636 24.5291 20.4381C24.5461 20.4793 24.5528 20.524 24.5488 20.5684L24.4134 22.0624L25.865 22.686C25.919 22.4091 25.9653 21.9832 25.8515 21.6091C25.8417 21.5768 25.8378 21.5431 25.8401 21.5094L25.9205 20.3415L24.8806 17.7656L22.5143 16.2333C22.4035 16.1616 22.3587 16.0215 22.4072 15.8987C22.4458 15.8012 22.4838 15.7096 22.5206 15.621C22.7276 15.1222 22.8644 14.7926 22.7275 14.3379C22.5375 13.707 22.5372 13.0593 22.7265 12.4647C22.9967 11.6161 23.4842 11.0689 24.0639 10.9635C24.2137 10.9363 24.3575 11.035 24.3858 11.1847C24.3869 11.1904 24.5021 11.785 24.7724 12.3829C25.0001 12.8864 25.3867 13.4977 25.9401 13.5678C26.0035 13.564 26.2896 13.5367 26.566 13.3444C26.982 13.055 27.1929 12.5323 27.1929 11.791C27.1929 11.0053 27.2509 10.5747 27.2932 10.2603C27.3585 9.77522 27.3829 9.59372 27.0556 8.61188C27.0176 8.49786 27.0574 8.37235 27.1542 8.30105C27.1633 8.29422 28.0411 7.63328 27.9985 6.9015ZM26.205 9.76358C26.1678 10.124 25.6194 10.0697 25.6534 9.70916C25.6906 9.34886 26.239 9.40291 26.205 9.76358Z"
                fill="white" />
            </svg>
            <svg v-if="card.travelType == 'walk'" width="22" height="22" viewBox="0 0 32 32" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.0261 13.8044C12.5573 11.7791 13.0802 9.74551 13.6031 7.72024C13.6363 7.59574 13.6695 7.46293 13.7359 7.18902C13.545 7.05622 13.3375 6.79891 13.0802 6.7325C11.3953 6.28429 9.58579 7.31352 9.11268 8.99849C8.72256 10.368 8.39885 11.7542 8.04194 13.132C7.90913 13.6384 8.09174 13.9206 8.58976 14.0368C9.32018 14.2111 10.034 14.4103 10.7644 14.5846C11.5281 14.7589 11.8269 14.568 12.0261 13.8044Z"
                fill="white" />
              <path
                d="M12.7814 16.7925C12.3 18.7928 11.802 20.7268 11.3787 22.6774C11.221 23.3829 11.7771 23.9971 12.4909 24.1133C13.1051 24.2129 13.6862 23.8311 13.8605 23.1422C14.2008 21.839 14.5245 20.5276 14.8316 19.2245C14.8648 19.0667 14.8399 18.826 14.7403 18.7264C14.1427 18.0873 13.5036 17.4897 12.7814 16.7925Z"
                fill="white" />
              <path
                d="M18.0603 6.58311C19.1062 6.58311 20.0109 5.67008 20.0358 4.60764C20.0524 3.5286 19.1228 2.57407 18.0603 2.57407C17.0145 2.57407 16.1015 3.4871 16.0849 4.54954C16.0683 5.63688 16.9896 6.58311 18.0603 6.58311Z"
                fill="white" />
              <path
                d="M23.5054 9.1147H22.7418C22.4097 9.1147 22.1441 9.38031 22.1441 9.71232V10.6254C21.1979 10.7831 20.4177 10.6669 19.8283 9.84512C19.5378 9.43841 19.1311 9.1147 18.7659 8.76609C17.2138 7.30523 15.0474 7.92775 14.5245 9.97793C14.1675 11.3558 13.8438 12.7419 13.4703 14.1115C13.2711 14.8253 13.4454 15.3731 13.9766 15.8877C15.0308 16.9004 16.0683 17.9296 17.0893 18.9755C17.2802 19.1913 17.3964 19.4652 17.413 19.7474C17.4545 20.7185 17.4213 21.6979 17.4296 22.6691C17.4379 23.524 17.9276 24.105 18.658 24.1299C19.3884 24.1548 19.9778 23.5323 19.9944 22.694C20.011 21.8889 19.9363 21.0754 20.011 20.2786C20.1438 18.8343 19.7287 17.6225 18.5501 16.7842C17.3715 15.9458 17.0976 14.9415 17.6537 13.6301C17.8612 13.132 17.9276 12.5676 18.0521 12.0364L18.1932 11.9202C19.0647 13.6135 20.6169 13.3645 22.1109 13.3312V14.1364V23.2418C22.1109 23.3663 22.1192 23.4908 22.1441 23.6153C22.169 23.9224 22.4263 24.1631 22.7335 24.1631H23.4971C23.8208 24.1631 24.0864 23.8975 24.0864 23.5738V9.71232C24.0947 9.38031 23.8374 9.1147 23.5054 9.1147Z"
                fill="white" />
            </svg>

            <template>
              <div>
              </div>
            </template>
          </div>
          <div class="price-row">
            <span>{{ $t("cms.activities.basePrice") }}:</span>
            <span class="price-value">{{ formatPrice(getPrice()) }}</span>
          </div>
          <div class="mt-auto">
            <p class="mb-12 description"> {{ sanitizeDescription(card.description) }}
            </p>
            <div class="text-start">
              <!-- eslint-disable-next-line max-len -->
              <button type="button" class="btn btn-sm btn-primary ms-auto" @click="openOffCanvas('the-case-create-offcanvas');
      caseCreateOpened = true">{{ $t("general.button.bookNow") }}</button>
            </div>
          </div>
          <TheCaseCreateCollaborators v-if="offCanvasToShow === 'the-case-create-offcanvas'" :template-data="card"
            @closed="closeOffCanvas(); caseCreateOpened = false" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import TheCaseCreateCollaborators from '@/components/case/parts/TheCaseCreateCollaborators.vue';
import useOffCanvasUtils from '@/helpers/OffCanvasUtils';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';

export default defineComponent({
  name: "TheActivityCard",
  components: {
    TheCaseCreateCollaborators,
    VIcon
  },
  props: {
    card: {
      type: Object,
      required: false,
    },
    index: {
      type: Number, // Define index as a prop of type Number
      required: true,
    },
  },
  data() {
    return {
      caseCreateOpened: false,
      ...useOffCanvasUtils(),
      cardBackgroundColor: "",
    };
  },
  methods: {
    cardHover(value) {

      this.$emit('cardHovered', value)

    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    sanitizeDescription(description) {
      // Remove <p> and </p> tags from the description using regex
      return description ? description.replace(/<\/?p>/g, '') : '';
    },
    setCardBackgroundColor() {
      const colors = ["#FF5733", "#33FF57", "#337AFF", "#FF33EA"];
      const gradientIndex = this.index % colors.length;
      const gradient = `linear-gradient(${colors[gradientIndex]}, ${colors[(gradientIndex + 1) % colors.length]})`;
      this.cardBackgroundColor = gradient;
    },
    getPrice() {
      // Try to get price from card object (supports multiple possible property names)
      const price = this.card?.base_price ?? this.card?.basePrice ?? this.card?.price;
      
      // If price exists and is greater than 0, return it
      if (price !== null && price !== undefined && price > 0) {
        return Number(price);
      }
      
      // Mock price for development (can be removed when API is ready)
      // TODO: Remove mock price when API provides base_price
      return 999;
    },
    formatPrice(price) {
      // Always format the price, even if it's the mock value
      const priceToFormat = price || 999;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(priceToFormat);
    },
  },
  mounted() {
    this.setCardBackgroundColor();
    this.sanitizeDescription();
  }
});
</script>

<style lang="scss" scoped>
.getQuote {
  background-color: yellow;
  border-color: yellow;
  color: black
}

.getQuote :hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.travelArrowIcon {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 10px;
}

.name-total-days-row {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: black;
  backdrop-filter: blur(5px);
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  font-size: 14px;
  text-align: left;

}

.hover_name_days {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  left: 0;
  width: 100%;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  align-items: center;
}

.hovered_name {
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;

}

.total-days {
  color: #EE2A7B;
  outline: line;
  border: 2px solid #EE2A7B;
  padding: 2px;
  border-radius: 5px;
  white-space: nowrap;
}

.background-image {
  color: #ffffff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.card .top-section {
  height: 30%;
}

.card .bottom-section {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 40px;
  background: #000000c2;
  backdrop-filter: blur(5px);
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  top: 0px;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
}

.card {
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;
  height: 18em;
  // max-width: 90%;
  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
  box-shadow: 0 0 6px 0 rgba(#202024, 0.12);
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
  /* Add transform transition */

  .card:hover {
    box-shadow: 0 10px 20px 0 rgba(#202024, 0.12);
  }

  .hover_content {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    padding: 1em 2em;
    transition: all 0.55s ease;
    visibility: hidden;
    color: #ffffff;
    z-index: 10;
    transition: all 0.5s ease;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transform: scale(0.05);
  }

  &:hover {
    box-shadow: 0 10px 20px 0 rgba(#202024, 0.12);
    animation: mediaHoverWrapperAppear .25s ease-in-out;

    .hover_content {
      top: 0px;
      transform: scale(1.05);
      animation: mediaHoverWrapperAppear 0.25s ease-in-out;
      visibility: visible;
    }
  }
}

.name-column {
  flex-grow: 1;
  /* Allow the name column to grow to fill remaining space */
  min-width: 0;
  /* Allow the name column to shrink */
}

.total-days-column {
  flex-shrink: 0;
  /* Prevent the total days column from shrinking */
}

.origin-destination-row {
  font-size: 13px;
  text-align: left;
  padding-right: 5px;
  padding-top: 5px;
}

.text-end {
  margin-left: 15px;
}

.travelType {
  font-size: 13px;
  text-align: left;
  padding-right: 5px;
  padding-top: 5px;
}

.price-row {
  font-size: 13px;
  text-align: left;
  padding-right: 5px;
  padding-top: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price-value {
  font-weight: 600;
  color: #EE2A7B;
}

.description {
  font-size: 13px;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
}
</style>
